const iconPath = {
    PUBLIC          : "/assets/images/world_icon.png",
    ME              : "/assets/images/lock_icon.png",
    FRIENDS         : "/assets/images/add_frined_icon2.png",
    PRIVATE         : "/assets/images/lock_icon.png",
    PUBLICWHITE     : "/assets/images/world_icon_2.png",
    MEWHITE         : "/assets/images/lock_icon2.png",
    FRIENDSWHITE    : "/assets/images/add_frined_icon3.png",
    PRIVATEWHITE    : "/assets/images/lock_icon2.png",

    LIKE            : "/assets/images/like_small.png",
    DISLIKE         : "/assets/images/dislike_small.png",
    LAUGH           : "/assets/images/haha_small.png",
    ANGRY           : "/assets/images/angry_small.png",
    LOVE            : "/assets/images/love_small.png",
    SAD             : "/assets/images/sad_small.png",
    'BREAK HEART'   : "/assets/images/heartbreak_small.png",
    BREAKHEART      : "/assets/images/heartbreak_small.png",
    DEFAULTREACTION : '/assets/images/like_dislike_goldspace.png',
    DEFAULTREACTIONBLACK : "/assets/images/like_dislike_goldspace.png",

    UNLIKE          : "/assets/images/like_dislike_goldspace.png",
    UNDISLIKE       : "/assets/images/like_dislike_goldspace.png",
    UNLAUGH         : "/assets/images/like_dislike_goldspace.png",
    UNANGRY         : "/assets/images/like_dislike_goldspace.png",
    UNLOVE          : "/assets/images/like_dislike_goldspace.png",
    UNSAD           : "/assets/images/like_dislike_goldspace.png",
    UNBREAKHEART    : "/assets/images/like_dislike_goldspace.png",

    ADDFRIEND       : "/assets/images/add_frined_icon.png",
    PENDINGFRIEND   : "/assets/images/pending.png",
    FRIEND          : "/assets/images/friend.png",


    DEFAULTUSER     : '/assets/images/default_user.png',
    BREAKIMAGE      : '/assets/images/no-image-found-360x260.png',
    ALBUMLIKE       : "/assets/images/love_small.png",
    ALBUMCOMMENT    : "/assets/images/commend_icon.png",
    ALBUMSHARE      : "/assets/images/shair_icon.png",
    LARGEADD        : "/assets/images/larg_add_icon.png",
    FEEDCOMMENT     : "/assets/images/new_timeline_comment.png",
    PROMOTIONCOMMENT  : "/assets/images/new_timeline_comment2.png",
    FEEDSHARE       : "/assets/images/new_timeline_share.png",
    
  };
  
  export default iconPath;